/* istanbul ignore file */
import BaseApi from '@lumapps/base-api';
import { ServerListRequest, ServerListResponse, PRIORITY } from '@lumapps/base-api/types';
import { CACHE_TYPE } from '@lumapps/cache';

import { Metadata, MetadataEntity } from '../types';

/**
 * Instance metadata API.
 * https://api.lumapps.com/docs/instance/metadata/list
 */
const instanceMetadataApi = new BaseApi({ path: 'instance/metadata' });

export interface InstanceListMetadataRequest extends ServerListRequest {
    withInheritance?: boolean;
    rootOnly?: boolean;
    instance: string;
    familyId?: string;
    canBeAppliedTo?: MetadataEntity[];
}

export const listInstanceMetadata = (params: InstanceListMetadataRequest) =>
    instanceMetadataApi.getCacheFirst<ServerListResponse<Metadata>>('list', CACHE_TYPE.MEMORY, PRIORITY.LOW, {
        // fallback on most common applicable entity "content" if not specified
        params: { canBeAppliedTo: [MetadataEntity.content], ...params },
    });
